import React from 'react'
import '../style/footer.scss'
import 'font-awesome/css/font-awesome.min.css';
import logoblack from '../images/logoblack.png';

const Footer = () => (
    <>
    <section id="footer" className="pt-5">
            <img src={logoblack} alt="logo" className="logo_black"/>
            <div className="container">
              <div className="row footerCol">
                <div className="col-md-4 my-2">
                  <h2 className="text-white teko">CROSSFIT DELIVERANCE</h2>
                  <br/>
                  <span><i className="fa fa-phone mr-2 my-2"></i> 253.686.4898</span>
                  <br/>
                  <span><i className="fa fa-map-marker mr-2 my-2"></i> 4535 Union Bay Pl NE </span>
                  <br/>
                  <span><i className="fa fa-clock-o  mr-2 my-2"></i> Mon - Fri 5:00am - 7:30pm</span>
                </div>

                <div className="col-md-4 my-2">
                  <h2 className="text-white teko">USEFULL LINKS</h2>
                  <a href="https://journal.crossfit.com/">Crossfit Journal</a>
                  <br/>
                  <br/>
                  <a href="https://romwod.com/?gclid=EAIaIQobChMI5sO53MXN3gIVD6vsCh06wA_pEAAYASAAEgI_LvD_BwE">ROMWOD</a>
                  <br/>
                  <br/>
                  <a href="www.crossfit.com">Crossfit.com</a>
                </div>

                
               {/* <div className="col-md-3 my-2">
                        <h2 className="text-white teko">LATEST POST</h2>
                        <div className="post">
                            <h5 className="teko post_title">MOBILITY FOR LIFTING</h5>
                            <p className="post_date">December 5, 2018</p>
                        </div>
                        <div className="post">
                            <h5 className="teko post_title">MOBILITY FOR LIFTING</h5>
                            <p className="post_date">December 5, 2018</p>
                        </div>
                        <div className="post">
                            <h5 className="teko post_title">MOBILITY FOR LIFTING</h5>
                            <p className="post_date">December 5, 2018</p>
                        </div>
                </div> */}

                <div className="col-md-4 my-2">
                    <h2 className="text-white teko">CONTACT US</h2>
                    <form className="footer-form"action="https://app.wodify.com/API/WebToLeadFormPostEntry_v1.aspx?" accept-charset="UTF-8" method="POST" id="wodifyLeadForm" name="wodifyLeadForm" onsubmit="return validateWodifyLeadForm();">

                    <input type="text" name="name" maxlength="50" required data-required placeholder="Name"/> 
                    <span id="errorname" name="errorname" style={{display: 'none', color: '#cc2626'}}> Required field!</span><br/>
                    <input type="email" name="email" maxlength="250" required data-required placeholder="Email"/> 
                    <span id="erroremail" name="erroremail" style={{display: 'none', color: '#cc2626'}}> Required field!</span><br/>
                    <textarea name="comments" maxlength="2000" rows="4" placeholder="Comment"/>
                    <input type="hidden" name="redirecturl" value="http://crossfitdeliverance.com/rates/"/>
                    <input type="hidden" name="apikey" value="csrdgwz4t6"/>
                    <br/>
                    <button className="primary-button-small" type="submit">Send Message</button>
                    </form>    
                </div>
                </div>
            </div>
        </section>
        <div className="py-2 footer">
            <div className="footer-logo ml-5 ">
                    <p className="d-inline copy_right">Copyrights 2017 © Crossfit Deliverance</p>
            </div>
            <div className="social mr-5">
                <a href="https://www.facebook.com/crossfitdeliverance/" target="_blank" className="social_media_button social_media_button--dark">
                    <i className="fa fa-facebook"></i>
                </a>
                <a href="https://www.youtube.com/channel/UCJwsU2VvviHvzMa5lPWcIeg/videos" target="_blank" className="social_media_button social_media_button--dark">
                    <i className="fa fa-youtube"></i>
                </a>
                <a href="https://www.instagram.com/crossfitdeliverance/" target="_blank" className="social_media_button social_media_button--dark">
                    <i className="fa fa-instagram"></i>
                </a>
                
               
                
            </div>
                
        </div>
    </>
)

function validateWodifyLeadForm(){
var reEmail = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
var returnValue = true;
var fieldname=document.forms['wodifyLeadForm']['name'].value; if(fieldname==null||fieldname=='') {document.getElementById('errorname').style.display='inline';returnValue=false;} else {document.getElementById('errorname').style.display='none';}var fieldemail=document.forms['wodifyLeadForm']['email'].value;  if(fieldemail==null||fieldemail==''||!reEmail.test(fieldemail)) {document.getElementById('erroremail').style.display='inline';returnValue=false;} else {document.getElementById('erroremail').style.display='none';} return returnValue;
};


export default Footer;
